import React from "react";
import { Box, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const LabReportViewer: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { reportId, reportUrl } = location.state || {};

  if (!reportUrl) {
    return (
      <Box p={2}>
        <Typography>No report found</Typography>
        <Typography
          sx={{ cursor: "pointer", color: "primary.main" }}
          onClick={() => navigate(-1)}
        >
          Go Back
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", height: "100vh" }}>
      <iframe
        src={reportUrl}
        title={`Report-${reportId}`}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </Box>
  );
};

export default LabReportViewer;
